// extracted by mini-css-extract-plugin
export default {"buttons":"Director_buttons__phz4J"};